<template>
  <tool-advance-filter-content
    :contentInfo="contentInfo"
    :baselineTitle="baselineRow.title"
    :headerbaseline="baselineHeader"
    :isNotShowGraph="true"
    :rowsbaseline="baselineRow.rows"
    @editableRowButtonClick="genericMethodClick"
    :addButtonText="addButtonText"
    :headers="headers"
    :rows="rows"
    :singleHeading="singleHeading"
    :isShowIcon="isShowIcon"
    :editableRowStyle="editableRowStyle"
    :gridButtonTemplate="gridButtonTemplate"
    @addRow="addRow"
    @onChange="OnOptionChange"
    @reset="reset"
    :singleHeadingOptions="singleHeadingOptions"
    :singleHeadingButtonText="singleHeadingButtonText"
    :gridSplitId="gridSplitId"
    @GridSelectionChange="AddNewTypeRow"
    :rowTemplateButton="rowTemplateButton"
    @OuterRowButtonClick="genericMethodClick"
    @rowTemplateButtonClick="genericMethodClick"
    :rowOuterButton="rowOuterButton"
    :emptyGridData="emptyGridData"
    @removeRow="removeRow"
    :tableViewSettings="tableSetting"
    :showTableView="showTable"
  ></tool-advance-filter-content>
</template>
<script>
import { ToolAdvanceFilterContent } from "../../component/tool";
import { LoanAdvanceFilterContent } from "../../mixin";
import { ICELoanIntegration } from "../../mixin";
import _ from "lodash";
import { AdvanceFilter, DATETYPE } from "../../helpers/constant";
import { CommonHelper } from "../../helpers";
import { mapGetters } from "vuex";
import {
  GET_SELECTED_LIABLITY_INFORMATION,
  GET_LIABLITY_INFORMATION,
} from "../../helpers/vuex-constants";

export default {
  props: {
    tableViewSettings: {
      type: Object,
    },
    showTableView: {
      type: Boolean,
      default: false,
    },
    baselineData: {
      type: Object,
    },
  },
  components: { ToolAdvanceFilterContent },
  mixins: [LoanAdvanceFilterContent, ICELoanIntegration],
  computed: {
    gridButtonTemplate() {
      let Loans = this.getLiablityInformation.filter(
        (sr) => sr.liabilityGuid == this.selectedLoanData.liabilityGuid
      );
      let ExistingData = Loans[0].advancedetails
        .filter((sr) => sr.typeId == AdvanceFilter.LoanTerm)
        .map(function (t) {
          let p = {};
          p.amount = t.amount;
          p.adjustedTerm = t.adjustedTerm;
          p.description = t.description;
          p.startDate = t.startDate;
          p.startDateType = t.startDateType.toString();
          return p;
        });
      if (ExistingData.length > 0) {
        let CurrentDataObject = [];
        for (let i = 0; i < this.rows.length; i++) {
          CurrentDataObject.push({
            amount: this.rows[i].Amount.value,
            adjustedTerm: this.rows[i].Term.value,
            description: this.rows[i].Description.value,
            startDate: this.rows[i].StartDate.value,
            startDateType: this.rows[i].StartDateType.value.toString(),
          });
        }
        let difference = _.isEqual(ExistingData, CurrentDataObject);
        this.enableResetButton(difference, "reset");
      } else {
        this.enableResetButton(false, "reset");
      }
      return this.gridButtonTemplatedata;
    },
    baselineFilterObject() {
      return Object.assign({}, this.baselineData);
    },
    ...mapGetters("loan", {
      selectedLoanData: GET_SELECTED_LIABLITY_INFORMATION,
      getLiablityInformation: GET_LIABLITY_INFORMATION,
    }),
  },
  mounted() {
    this.rows = this.fillGrid();
  },
  data() {
    return {
      emptyGridData: {
        title: "You Have No Additional Loan Term",
        message: "",
        imagepath: "../../assets/icons/dollar.svg",
        buttonVisible: true,
        list: [],
      },
      rowOuterButton: [
        // {
        //   icon: "trash",
        //   size: "large",
        //   variation: "icon-only",
        //   text: "Add New",
        //   callBackMethod: "DeleteSubtype",
        //   isdisabled: false,
        //   key: "deletesubtype",
        // },
      ],
      rowTemplateButton: [
        {
          icon: "plus",
          size: "medium",
          variation: "flat",
          text: "Add New",
          callBackMethod: "AddNewTypeRow",
          isdisabled: false,
          key: "AddNewTypeRow",
        },
      ],

      singleHeadingButtonText: "",
      gridSplitId: "",
      editableRowStyle: { paddingBottom: "15px" },
      baselineRow: {
        title: "Baseline Loan Term",
        rows: [
          {
            loanTerm: {
              value: this.baselineData.loanTerm,
            },
            loanMonth: {
              value: this.baselineData.loanMonth,
            },
          },
        ],
      },
      baselineHeader: this.getEditBaselineHeader(),
      contentInfo: {
        heading: "Loan Term",
        subHeading:
          "You can enter in loan term details at different time periods.",
      },
      addButtonText: "Add new",
      isShowIcon: false,
      singleHeading: "Loan Term Adjustments",
      singleHeadingOptions: [
        {
          key: 1,
          value: "",
          fields: ["Term", "Amount", "StartDate", "Description"],
          overlapvalidations: false,
        },
      ],
      headers: [
        {
          type: "FormatInput",
          label: "Years Remaining ",
          isAllowOnlyNumber: true,
          currencyFormat: "",
          appendText: "",
          style: {
            width: "80px",
          },
          key: "Term",
          length: 3,
          max: 100,
        },
        {
          type: "FormatInput",
          label: "Months Remaining ",
          isAllowOnlyNumber: true,
          currencyFormat: "",
          appendText: "",
          style: {
            width: "80px",
          },
          key: "Amount",
          length: 2,
          max: 12,
        },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          showLeft: false,
          typing: true,
          label: "Date",
          cols: 1,
          key: "StartDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,
          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },
        {
          type: "Input",
          label: "Description",
          placeholder: "e.g Change in Rates",
          isAllowToAddNextRow: true,
          Option: "",
          key: "Description",
          length: 200,
        },
        {
          type: "Icon",
          label: "",
          iconText: "Validation",
          icon: "check",
          cols: 1,
          isShowDelete: true,
          isShowSuccess: false,
          class: "cf-Icon-Align",
          style: {
            width: "50px",
          },
          data: [
            {
              label: "",
              iconText: "Delete",
              icon: "trash",
              type: "icon",
              path: "",
              action: "delete",
            },
          ],
        },
      ],
      rows: [],

      gridButtonTemplatedata: [
        {
          size: "medium",
          variation: "secondary",
          isdisabled: true,
          text: "Reset",
          callBackMethod: "reset",
          key: "reset",
        },
      ],
    };
  },

  async created() {},
  beforeMount() {
    this.validations(
      this.baselineFilterObject.advancedetails,
      AdvanceFilter.LoanTerm
    );
  },
  beforeDestroy() {
    this.fillLoanModel(AdvanceFilter.LoanTerm);
    this.validations(
      this.baselineFilterObject.advancedetails,
      AdvanceFilter.LoanTerm
    );
  },
  methods: {
    getEditBaselineHeader() {
      return [
        {
          type: "Input",
          label: "Years Remaining",
          currencyFormat: "",
          appendText: "",
          key: "loanTerm",
          isAllowOnlyNumber: true,
          length: 2,
          max: 100,
          class: "",
          cols: 2,
          isdisabled: true,
          isEditiable: true,
        },
        {
          type: "Input",
          label: "Months Remaining",
          currencyFormat: "",
          appendText: "",
          key: "loanMonth",
          isAllowOnlyNumber: true,
          class: "",
          cols: 2,
          isdisabled: true,
          isEditiable: true,
        },
        {
          type: "EditButton",
          label: "Edit",
          variation: "flat",
          key: "edit",
          icon: "pencil",
          class: "flexiblePosition",
          cols: 4,
          isdisabled: false,
          align: "center",
          callBackMethod: "editBaseLineButton_Click",
        },
      ];
    },

    DeleteSubtype(data) {
      this.rows = this.rows.filter((x) => x.subTypeId.value != data);
    },

    GridSelectionChange(data) {
      this.rows.push(this.fillData(undefined, data.key));
    },
    async UpdateGraph() {
      this.fillLoanModel(AdvanceFilter.LoanTerm);
      await this.UpdateGraphByICEApi();
    },
    updateerrors() {
      let gridRows = [];

      let data = this.baselineFilterObject.advancedetails.filter(
        (sr) => sr.typeId.value == AdvanceFilter.LoanTerm
      );
      for (let i = 0; i < data.length; i++) {
        gridRows.push({
          Amount: {
            value: data[i].amount.value,
            IsError: data[i].amount.IsError,
            ErrorText: data[i].amount.ErrorText,
          },
          Term: {
            value: data[i].adjustedTerm.value,
            IsError: data[i].adjustedTerm.IsError,
            ErrorText: data[i].adjustedTerm.ErrorText,
          },
          Description: {
            value: data[i].description.value,
            IsError: data[i].description.IsError,
            ErrorText: data[i].description.ErrorText,
          },
          StartDateType: {
            value: data[i].startDateType.value,
            IsError: data[i].startDateType.IsError,
            ErrorText: data[i].startDateType.ErrorText,
          },
          StartDate: {
            value: data[i].startDate.value,
            IsError: data[i].startDate.IsError,
            ErrorText: data[i].startDate.ErrorText,
          },
        });
      }
      return gridRows;
    },
    getUserInputData(userInputRows) {
      let addtionalData = [];
      let rows = Object.assign([], userInputRows);
      rows = this.ResetMonthPickerValue(rows);

      for (let i = 0; i < rows.length; i++) {
        if (
          !this.validatebyrow(rows[i], rows[i].subTypeId.value) &&
          (rows[i].Amount.value > 0 || rows[i].Term.value > 0)
        ) {
          addtionalData.push({
            amount: {
              value: rows[i].Amount.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].Amount.disable,
            },
            description: {
              value: rows[i].Description.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].Description.disable,
            },
            adjustedTerm: {
              value: rows[i].Term.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].Term.disable,
            },
            startDateType: {
              value: rows[i].StartDateType.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].StartDateType.disable,
            },
            startDate: {
              value: rows[i].StartDate.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].StartDate.disable,
            },
            typeId: { value: AdvanceFilter.LoanTerm },

            subTypeId: {
              value: rows[i].subTypeId.value,
              IsError: false,
              ErrorText: [],
            },
            newRow: false,
          });
        }
      }
      return addtionalData;
    },

    fillGrid() {
      let gridRows = [];

      if (this.baselineData.advancedetails != null) {
        let data = this.baselineData.advancedetails.filter(
          (sr) => sr.typeId.value == AdvanceFilter.LoanTerm
        );
        if (data != null && data.length > 0) {
          gridRows = this.emptyGridRow(data);
        }
        this.getinsertEmptyRows(gridRows);
      }

      // if (this.baselineData.advancedetails == null) {
      //   gridRows.push(this.emptyGridRow());
      // } else {
      //   let data = this.baselineData.advancedetails.filter(
      //     (sr) => sr.typeId.value == AdvanceFilter.LoanTerm
      //   );
      //   if (data == null || data.length == 0) {
      //     gridRows.push(this.emptyGridRow());
      //   } else {

      //     gridRows = this.emptyGridRow(data);
      //   }
      // }
      return gridRows;
    },

    fillData(data, subtypeid) {
      let IsDataundfined = data == undefined;
      let startDateType = IsDataundfined
        ? 0
        : data.startDateType.value == 0
        ? DATETYPE.Other
        : data.startDateType.value;

      let emptyObject = {
        Amount: {
          value: IsDataundfined ? 0 : data.amount.value,
          IsError: IsDataundfined ? false : data.amount.IsError,
          ErrorText: IsDataundfined ? [] : data.amount.ErrorText,
          disable: IsDataundfined ? false : data.amount.disable,
        },
        Description: {
          value: IsDataundfined ? "" : data.description.value,
          IsError: IsDataundfined ? false : data.description.IsError,
          ErrorText: IsDataundfined ? [] : data.description.ErrorText,
          disable: IsDataundfined ? false : data.description.disable,
        },
        Term: {
          value: IsDataundfined ? 0 : data.adjustedTerm.value,
          IsError: IsDataundfined ? false : data.adjustedTerm.IsError,
          ErrorText: IsDataundfined ? [] : data.adjustedTerm.ErrorText,
          disable: IsDataundfined ? false : data.adjustedTerm.disable,
        },
        StartDateType: {
          value: IsDataundfined ? 0 : data.startDateType.value,
          IsError: IsDataundfined ? false : data.startDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.startDateType.ErrorText,
          disable: IsDataundfined ? false : data.startDateType.disable,
        },
        StartDate: {
          value: IsDataundfined ? "" : data.startDate.value,
          IsError: IsDataundfined ? false : data.startDate.IsError,
          ErrorText: IsDataundfined ? [] : data.startDate.ErrorText,

          text: IsDataundfined
            ? ""
            : this.startOptionsNew().filter((x) => x.value == startDateType)[0]
                .text,
        },
        subTypeId: {
          value: IsDataundfined ? subtypeid : data.subTypeId.value,
          IsError: IsDataundfined ? false : data.subTypeId.IsError,
          ErrorText: IsDataundfined ? [] : data.subTypeId.ErrorText,
          disable: IsDataundfined ? false : data.subTypeId.disable,
        },
        newRow: IsDataundfined ? true : false,
      };
      return emptyObject;
    },
    emptyGridRow(data) {
      if (data == undefined) {
        return this.fillData();
      } else {
        let gridData = [];
        for (let i = 0; i < data.length; i++) {
          gridData.push(this.fillData(data[i]));
        }
        return gridData;
      }
    },

    ResetMicrocopyBelowText(year) {
      let microcopyBelowText = CommonHelper.calculateMonth(year);
      this.baselineRow.rows[0].loanTerm.microcopyBelow = microcopyBelowText;
    },
    ResetMicrocopyBelowTextInGrid(year, index) {
      let microcopyBelowText = CommonHelper.calculateMonth(year);
      this.rows[index].Amount.microcopyBelow = microcopyBelowText;
    },

    editBaseLineButton_Click() {
      this.baselineHeader = [
        {
          type: "Input",
          label: "Years Remaining",
          currencyFormat: "",
          appendText: "",
          key: "loanTerm",
          isAllowOnlyNumber: true,
          class: "",
          cols: 2,
          length: 3,
          max: 100,
          isdisabled: false,
        },
        {
          type: "Input",
          label: "Months Remaining",
          currencyFormat: "",
          appendText: "",
          key: "loanMonth",
          isAllowOnlyNumber: true,
          class: "",
          cols: 2,
          length: 2,
          max: 12,
          isdisabled: false,
        },
        {
          type: "Button",
          label: "Save",
          variation: "primary",
          key: "save",

          class: "shrink",
          cols: 1,
          isdisabled: false,
          callBackMethod: "saveBaseLineButton_Click",
        },
        {
          type: "Button",
          label: "Cancel",
          variation: "flat",
          key: "cancel",

          class: "shrink",
          cols: 1,
          isdisabled: false,
          callBackMethod: "cancelBaseLineButton_Click",
        },
      ];
    },
    saveBaseLineButton_Click(data) {
      this.baselineFilterObject.loanTerm = data[0].loanTerm.value;
      this.baselineFilterObject.loanMonth = data[0].loanMonth.value;
      this.$emit("resetBaselineData", this.baselineFilterObject);
      this.cancelBaseLineButton_Click();
    },
    cancelBaseLineButton_Click() {
      this.baselineRow.rows[0].loanTerm.value =
        this.baselineFilterObject.loanTerm;
      this.baselineRow.rows[0].loanMonth.value =
        this.baselineFilterObject.loanMonth;

      this.baselineHeader = this.getEditBaselineHeader();
    },

    reset() {
      let selectedRepData = this.selectedLoanData.advancedetails.filter(
        (sr) => sr.typeId == AdvanceFilter.LoanTerm
      );
      let advanceData = [];
      if (selectedRepData.length > 0) {
        for (let i = 0; i < selectedRepData.length; i++) {
          advanceData.push({
            Amount: {
              value: selectedRepData[i].amount,
            },
            Term: { value: selectedRepData[i].adjustedTerm },
            Description: { value: selectedRepData[i].description },
            StartDate: {
              value: selectedRepData[i].startDate,
              disable:
                selectedRepData[i].startDateType != DATETYPE.Other
                  ? true
                  : false,
            },
            StartDateType: {
              value: selectedRepData[i].startDateType,
            },
            typeId: {
              value: AdvanceFilter.LoanTerm,
            },
            subTypeId: {
              value: selectedRepData[i].subTypeId,
            },
          });
        }
        this.rows = advanceData;
      } else {
        this.rows = this.fillGrid();
      }
      this.enableResetButton(false);
    },
  },
};
</script>
<style lang="scss" module></style>
